import React from 'react'
import SEO from '../components/SEO'
import Layout from '../components/layout'
import Portfolio from '../templates/portfolio'

function index() {
  return (
    <Layout>
      <SEO
        title="Chintan Agrawal | Big Data Engineer"
        description="Hi I am currently working for AWS PS in Bangalore. Welcome to my place on web ! "
      />
      <Portfolio />
    </Layout>
  )
}

export default index
